/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Room_Sensor_Temperature_Valve_CountInputs */



/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Temperature calculated from {count} thermostatic head" |
* | "other" | "Temperature calculated from {count} thermostatic heads" |
*
* @param {Room_Sensor_Temperature_Valve_CountInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const room_sensor_temperature_valve_count = /** @type {((inputs: Room_Sensor_Temperature_Valve_CountInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Room_Sensor_Temperature_Valve_CountInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		const countPlural = registry.plural("en", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`Temperature calculated from ${i?.count} thermostatic head`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`Temperature calculated from ${i?.count} thermostatic heads`);
		return /** @type {LocalizedString} */ ("room_sensor_temperature_valve_count");
	}
	{
		const countPlural = registry.plural("fr", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`Température calculée à partir de ${i?.count} tête th.`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`Température calculée à partir de ${i?.count} têtes th.`);
		return /** @type {LocalizedString} */ ("room_sensor_temperature_valve_count");
	}
});